import axios from 'axios';

const setupAxios = () => {
    if (!window.walkuere_app_data || !window.walkuere_app_data.concord_url) {
        return null;
    }

    const url = window.walkuere_app_data.concord_url;
    const customHeaders = {
        "platform": "web", // Add your custom header(s) here
        "app-version": "1.10.290",
    };

    return axios.create({
        baseURL: url,
        headers: customHeaders,
    });
};

const fetchData = async (graphqlQuery, variables) => {
    const axiosInstance = setupAxios();

    if (!axiosInstance) {
        console.error('Error setting up Axios instance');
        return null;
    }

    try {
        const response = await axiosInstance.post('', { 
            query: graphqlQuery,
            variables,
        });

        if (response && response.data && response.data.data) {
            return response.data.data;
        } else {
            console.error('Invalid response:', response);
            return null;
        }
    } catch (error) {
        console.error('Error fetching data:', error);
        return null;
    }
};

export default {
    async getMoreData(graphqlQuery,variables) {
        const result = await fetchData(graphqlQuery,variables);
        return result;
    },

    getAjaxPublicDataUrl: function () {
        return "/wp-json/fidelio/v1/get-public-data";
    },
    
    async loadPublicData(payload) {
        try {
            const url = payload.url;
            const response = await axios.get(url, { timeout: 1550 });
            // Handle the response data if it exists
            return response && response.data !== undefined ? response.data : this.handlePostRequest(payload);
        } catch (getError) {
            // Log the error from the GET request
        }
    
        // If the GET request fails, try the POST request
        return this.handlePostRequest(payload);
    },
    
    async handlePostRequest(payload) {
        try {
            const response = await axios.post(this.getAjaxPublicDataUrl(), {
                page: payload.page,
                'page-size': payload.pagesize,
                'cat-name': payload.querystring,
                transient_key: payload.transientKey,
                query: payload.query
            });
    
            // Handle the response data
            return response.data;
        } catch (postError) {
            // Log the error from the POST request
        }
    }
};
